<script lang="ts">
  import { gaugeStarIn, gaugeStarOut } from '~/animations.svelte';
  import Star from '../../icons/Star.svelte';
  import { DailyGame } from '~/store/daily.svelte';
  import { getGame } from '~/store/GameContext.svelte';

  type Props = {
    ratio: number;
    radius: number;
    color: string;
  };
  const props: Props = $props();

  const game = $derived(getGame<DailyGame>().current);
  const STAR_OFFSET = -6;
  const innerRadius = $derived(props.radius - STAR_OFFSET);
  const starSize = $derived(props.radius > 90 ? 24 : 20);

  const getStarRotation = $derived(
    (threshold: number) =>
      `rotate(${(360 * props.ratio * threshold) / game.totalSwaps - 120}deg)`,
  );
</script>

<div class="stars" style="--star-offset: {STAR_OFFSET}px">
  {#each game.starMap[game.variant].filter(([s, t]) => t <= game.swaps) as [s, t] (s)}
    <div
      in:gaugeStarIn
      out:gaugeStarOut
      class="star"
      style="
        --size: {2 * innerRadius}px;
        transform: {getStarRotation(t)};
      "
    >
      <div
        class="star-background"
        style="
          --size: {starSize + 4}px;
          background-color: {props.color};
        "
      ></div>
      <div style="margin-top: {-starSize - 3.5}px;">
        <Star size={starSize} />
      </div>
    </div>
  {/each}
</div>

<style lang="scss">
  .stars {
    position: absolute;
    top: var(--star-offset);
    left: var(--star-offset);
  }
  .star-background {
    align-self: center;
    width: var(--size);
    height: var(--size);
    border-radius: 999px;
    margin-left: auto;
    margin-right: auto;
  }
  .star {
    transition: all 0.2s;
    text-align: center;
    transform-origin: center;
    position: absolute;
    letter-spacing: 8px;
    width: var(--size);
    height: var(--size);
  }
</style>
